import { useCallback } from 'react';
import styled from 'styled-components';

import QrCode from 'dashboard/components/QrCode';
import FormMfaCode, { FormMfaCodeData } from 'dashboard/forms/FormMfaCode';
import Spacer from 'design-system/components/Spacer';
import { Heading, Paragraph } from 'design-system/components/Text';

const QrCodeContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

interface SetupMfaTotpProps {
  onEnable: (code: string) => Promise<void>;
  onCancel: () => void;
  totpProvisioningUri: string;
}

const CODE_LENGTH = 6;

const SetupMfaTotp = ({ onEnable, onCancel, totpProvisioningUri }: SetupMfaTotpProps) => {
  const handleEnable = useCallback(({ code }: FormMfaCodeData) => onEnable(code), []);
  const qrParagraph = 'Scan this QR code with your chosen authenticator app.';

  return (
    <>
      <Heading size='sm'>One-time password 2-factor authentication</Heading>
      <Spacer height={2.5} />
      <Paragraph>{qrParagraph}</Paragraph>
      <Paragraph>
        We recommend using an application such as{' '}
        <a href='https://authy.com/' target='_blank' rel='noreferrer'>
          Authy
        </a>
        ,{' '}
        <a href='https://1password.com/' target='_blank' rel='noreferrer'>
          1Password
        </a>
        , or{' '}
        <a href='https://lastpass.com/auth/' target='_blank' rel='noreferrer'>
          LastPass Authenticator
        </a>
        .
      </Paragraph>
      <Spacer height={2.5} />
      <QrCodeContainer data-test='confirm-mfa-totp-modal__qr-code'>
        <QrCode value={totpProvisioningUri} accessibleTitle={qrParagraph} />
      </QrCodeContainer>
      <Spacer height={2.5} />
      <Paragraph>Next, enter the verification code generated by your authenticator app.</Paragraph>
      <Spacer height={2.5} />
      <FormMfaCode codeLength={CODE_LENGTH} onCancel={onCancel} onSubmit={handleEnable} />
    </>
  );
};

export default SetupMfaTotp;
